module.exports = __webpack_public_path__ + "img/companies-icon.f6b27556.png";